

import { API_CENTRE } from "./config";
import _o2sService from "./_o2sServices";
import { IFilter } from "../models/filters/filter";
import { IProductionSamplingEventFilter } from "../models/filters/productionSamplingEventFilter";
import { IProductionSamplingEventForm } from "../models/forms/productionSamplingEventForm";
import { IProductionSamplingEventPDTO } from "../models/dtos/productionSamplingEventPDTO";


export default class ProductionSamplingEventService extends _o2sService {

    protected static override mainUrl:string = API_CENTRE + "/api/v1/productionSamplingEvents";

    protected static override  getUrlFilter<F extends IProductionSamplingEventFilter>(filter?: F):string {
        let url = super.getUrlFilter(filter as IFilter);
        if ( filter != null)
        {
            if(filter.productionId != undefined)
                url += `&ProductionId=${filter.productionId}`;
            if(filter.samplingEventId != undefined)
                url += `&SamplingEventId=${filter.samplingEventId}`;
            if(filter.centerId != undefined)
                url += `&CenterId=${filter.centerId}`;
        }
        
        return url;
    }

    public static override toDTO(obj:IProductionSamplingEventForm):IProductionSamplingEventPDTO {
        const dto = super.toDTO(obj) as IProductionSamplingEventPDTO;
        return dto;
    }
}